var _defs, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPickupTruckBulk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ae4bed6a-6fc9-44e9-96d9-45db7645af9d",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e84263aa-0851-4b74-a844-27c8923f81bc,.f6ba0bd5-bfee-4931-8a93-344d1f64ed99{fill:none;}.f6ba0bd5-bfee-4931-8a93-344d1f64ed99{clip-rule:evenodd;}.a7272e9b-974f-4f75-8781-7ab358796ae3{clip-path:url(#f9871fb4-d637-4410-80dc-00df2f744bb4);}.fa2e9a2d-fba4-495e-92ff-4b29a0503a9e{fill:#b2c3c9;}.ac674b8b-14b2-4d31-8d4c-ffbec83b7685{clip-path:url(#ea6edfd9-4ad0-421d-a756-7290dcc403cb);}.eaac0e00-5e9d-44ab-a6b8-977d988de336{clip-path:url(#ee4c7849-24f1-4259-a81b-aad41f95d9fb);}.ee8c3f9d-d7b8-433e-80ae-4da6d3f1572c{clip-path:url(#b96483d7-22ee-4c6f-ab79-ed2f67ce1f00);}.bbf3953b-9ee1-43ba-8d53-e8621f5c4458{clip-path:url(#acc6ab01-256c-438b-ae6e-27e2fe4f3727);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "f9871fb4-d637-4410-80dc-00df2f744bb4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f6ba0bd5-bfee-4931-8a93-344d1f64ed99",
    d: "M19.57,13.48H11.44c-.51,0-2.19-3.41-2.19-4,0-1.9.63-5,2.74-5s3.93,0,7.46,0C23.78,4.47,24.5,13.49,19.57,13.48Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ea6edfd9-4ad0-421d-a756-7290dcc403cb"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e84263aa-0851-4b74-a844-27c8923f81bc",
    d: "M6.67,11.75a.28.28,0,0,1-.26.3H1.87a.28.28,0,0,1-.26-.29V11.5a.66.66,0,0,1,0-.28L3.09,8.48a.62.62,0,0,1,.58-.39H6.19c.41,0,.48,0,.48.5Zm15.22,3.59a1,1,0,0,0-.95-.94H8.34a.59.59,0,0,1-.59-.6V7.32a.18.18,0,0,0-.18-.18H3.27a.94.94,0,0,0-.86.57l-2.12,4v0a1,1,0,0,0-.08.38l0,7.55a1,1,0,0,0,1,.95h.14a.18.18,0,0,0,.18-.18,3.18,3.18,0,1,1,6.35,0,.18.18,0,0,0,.18.18H9a.18.18,0,0,0,.18-.18,3.17,3.17,0,0,1,5.87-1.69.17.17,0,0,0,.3,0,3.17,3.17,0,0,1,5.84,1.74.22.22,0,0,1,0,.08,1,1,0,0,0,.71-1Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ee4c7849-24f1-4259-a81b-aad41f95d9fb"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e84263aa-0851-4b74-a844-27c8923f81bc",
    d: "M4.69,21.34a.9.9,0,1,1,.89-.9A.89.89,0,0,1,4.69,21.34Zm0-3.44a2.54,2.54,0,1,0,2.52,2.54A2.52,2.52,0,0,0,4.69,17.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b96483d7-22ee-4c6f-ab79-ed2f67ce1f00"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e84263aa-0851-4b74-a844-27c8923f81bc",
    d: "M12.37,21.34a.9.9,0,1,1,.89-.9A.89.89,0,0,1,12.37,21.34Zm0-3.44a2.54,2.54,0,1,0,2.52,2.54A2.52,2.52,0,0,0,12.37,17.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "acc6ab01-256c-438b-ae6e-27e2fe4f3727"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e84263aa-0851-4b74-a844-27c8923f81bc",
    d: "M18,21.35a.89.89,0,1,1,.89-.89A.88.88,0,0,1,18,21.35Zm0-3.43a2.54,2.54,0,1,0,2.52,2.54A2.52,2.52,0,0,0,18,17.92Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a7272e9b-974f-4f75-8781-7ab358796ae3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "fa2e9a2d-fba4-495e-92ff-4b29a0503a9e",
    x: 4.25,
    y: -0.52,
    width: 23.73,
    height: 19
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "ac674b8b-14b2-4d31-8d4c-ffbec83b7685"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "fa2e9a2d-fba4-495e-92ff-4b29a0503a9e",
    x: -4.8,
    y: 2.14,
    width: 31.72,
    height: 23.42
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "eaac0e00-5e9d-44ab-a6b8-977d988de336"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "fa2e9a2d-fba4-495e-92ff-4b29a0503a9e",
    x: -2.82,
    y: 12.9,
    width: 15.03,
    height: 15.08
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "ee8c3f9d-d7b8-433e-80ae-4da6d3f1572c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "fa2e9a2d-fba4-495e-92ff-4b29a0503a9e",
    x: 4.86,
    y: 12.9,
    width: 15.03,
    height: 15.08
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "bbf3953b-9ee1-43ba-8d53-e8621f5c4458"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "fa2e9a2d-fba4-495e-92ff-4b29a0503a9e",
    x: 10.53,
    y: 12.92,
    width: 15.03,
    height: 15.08
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickupTruckBulk);
export default __webpack_public_path__ + "static/media/pickupTruckBulk.ad7f82bedd27f96c25d0034c2b934163.svg";
export { ForwardRef as ReactComponent };